export default __webpack_public_path__ + "static/media/em_hoodie_2.5e629f21.jpg";